'use strict';

class TimeTrack {
  constructor($scope, $window, $sce, $filter, I18N, timeTrackingService) {
    this.$scope = $scope;
    this.$window = $window;
    this.$sce = $sce;
    this.$filter = $filter;
    this.timeTrackingService = timeTrackingService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};
    this.daysOfWeek = [];
    this.selectedDay = new Date();
    this.selectedDayEntries = [];
    this.dayTotal = '0:00';

    this.timeTrack = {
      entryDate: moment().format('YYYY-MM-DD'),
      number: null,
      projectNumber: null,
      taskNumber: null,
      comment: null,
      hours: null
    };

    this.projects = [];
    this.tasks = [];
    //required for hidden input
    this.pickedDate = null;

    this.picker = new Pikaday({
      field: $('#datePicker')[0]
    });

    this.$scope.$watch('$ctrl.pickedDate', (val) => {
      if (val) {
        let v = moment(val, 'YYYY-MM-DD').toDate();

        this.selectDay(v);
        this.loadDaysOfWeek();
      }
    });

    this.loadDaysOfWeek();
    this.loadProjects();
    this.loadEntries();
  }

  openPicker() {
    this.picker.show();
  }

  loadProjects() {
    this.timeTrackingService.getProjects()
      .then((resp) => {
        if (resp.data) {
          this.projects = resp.data;
          if (this.projects.length > 0) {
            this.timeTrack.projectNumber = this.projects[0].number;
            this.loadTasks(this.projects[0].number);
          }
        }
      });
  }

  cancel() {
    this.timeTrack = {
      entryDate: moment(this.selectedDay).format('YYYY-MM-DD'),
      number: null,
      projectNumber: null,
      taskNumber: null,
      comment: null,
      hours: null
    };
    if (this.projects && this.projects.length > 0) {
      this.timeTrack.projectNumber = this.projects[0].number;
      this.loadTasks(this.projects[0].number);
    }
  }

  saveOrUpdate() {
    if (this.timeTrack.projectNumber && this.timeTrack.taskNumber && this.timeTrack.hours) {
      if (this.timeTrack.number) {
        this.timeTrackingService.updateEntry(this.timeTrack.number, this.timeTrack)
          .then(() => {
            this.loadEntries();
          });
      } else {
        this.timeTrackingService.saveEntry(this.timeTrack)
          .then(() => {
            this.loadEntries();
        });
      }
    }
  }

  calculateDayTotal() {
    this.dayTotal = '0:00';
    let hours = 0;
    let mins = 0;

    this.selectedDayEntries.forEach((e) => {
      let hoursMinutes = e.hours.split(':');
      hours += parseInt(hoursMinutes[0], 10);
      if (hoursMinutes.length > 1) {
        mins += parseInt(hoursMinutes[1], 10);
      }
    });

    let extraHours = Math.floor(mins / 60);
    hours += extraHours;
    let minutes = mins % 60;
    let extraZero = minutes < 10 ? '0' : '';
    let res = hours + ':' + extraZero + minutes;
    this.dayTotal = res;
  }


  loadTasks(projectNumber) {
    this.tasks = [];
    if (this.projects) {
        this.projects.forEach((e) => {
          if (projectNumber === e.number) {
            this.tasks = e.tasks;
            this.timeTrack.taskNumber = this.tasks[0].number;
            this.timeTrack.hourlyRate = this.tasks[0].hourlyRate;
          }
        });
    }
  }

  editTimeTrack(index) {
    let clone = angular.copy(this.selectedDayEntries[index]);
    this.loadTasks(clone.projectNumber);
    this.timeTrack = clone;
  }

  taskChanged() {
    if (this.tasks) {
      this.tasks.forEach((e) => {
        if (this.timeTrack.taskNumber === e.number) {
          this.timeTrack.hourlyRate = e.hourlyRate;
        }
      });
    }
  }

  deleteTimeTrack(index) {
    swal({
      title: 'Bekreft fjerning',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: true,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.timeTrackingService.deleteEntry(this.selectedDayEntries[index].number)
          .then(() => {
            this.loadEntries();
          });
        //fix for swal
        // this.loadEntries();
        // this.$scope.$apply();
      }
    });
  }

  loadDaysOfWeek() {
    let s = moment(this.selectedDay);
    let monday = s.startOf('isoWeek');

    let week = [];
    week.push(monday.toDate());
    for (let i = 1; i <= 6; i++) {
      let day = monday.add(1, 'days');
      week.push(day.toDate());
    }
    this.daysOfWeek = week;
  }

  loadPreviousWeek() {
    this.selectedDay.setDate(this.selectedDay.getDate() - 7);
    this.selectDay(this.selectedDay);
    this.loadDaysOfWeek();
  }

  loadNextWeek() {
    this.selectedDay.setDate(this.selectedDay.getDate() + 7);
    this.selectDay(this.selectedDay);
    this.loadDaysOfWeek();
  }

  loadCurrentWeek() {
    this.selectedDay = new Date();
    this.selectDay(this.selectedDay);
    this.loadDaysOfWeek();
  }

  loadEntries() {
    let date = moment(this.selectedDay).format('YYYY-MM-DD');
    this.timeTrackingService.getEntries(date)
      .then((resp) => {
        this.selectedDayEntries = [];
        if (resp.data) {
          this.selectedDayEntries = resp.data;
          this.cancel();
          this.calculateDayTotal();
        }
    });
  }

  selectDay(day) {
    if (!day) {
      return;
    }
    this.selectedDayEntries = [];
    this.selectedDay = day;

    this.timeTrack = {
      entryDate: moment(this.selectedDay).format('YYYY-MM-DD'),
      number: null,
      projectNumber: null,
      taskNumber: null,
      comment: null,
      hours: null
    };
    this.loadEntries();
  }
}

TimeTrack.$inject = ['$scope', '$window', '$sce', '$filter', 'I18N', 'timeTrackingService'];

const timeTrack = {
  controller: TimeTrack,
  templateUrl: 'time-track/edit.html'
};

angular
  .module('SendRegning')
  .component('timeTrack', timeTrack)
  .config(($routeProvider) => {
    $routeProvider
      .when('/timeregistrering', {
        title: 'Timeregistrering',
        template: '<time-track />',
        secure: true
      });
  });
